const helper = {
    objectCopy(object) {
        return JSON.parse(JSON.stringify(object));
    } 
}

export default helper;